// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1jECN","header":"MergedInvoice_header__r6Y_t"};